const Utils = (function() {
    const isTouchScreen = (('createTouch' in document) || ('ontouchend' in window) || (navigator.MaxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0));
    const clickEvent = isTouchScreen ? 'touchstart' : 'click';

    return {
        isTouchScreen: isTouchScreen,
        clickEvent: clickEvent
    }
})();
